// extracted by mini-css-extract-plugin
export var container = "_59-0";
export var fallback = "_59-5";
export var fallbackIcon = "_59-6";
export var hidden = "_59-2";
export var image = "_59-3";
export var loaded = "_59-4";
export var placeholder = "_59-1";